<div [class]="hostClasses">
  <div *ngIf="icon" class="pay-kpi__icon-wrap">
    <lucide-icon [name]="icon" [size]="16"></lucide-icon>
  </div>

  <div class="pay-kpi__body">
    <span class="pay-kpi__value">{{ value }}</span>

    <span
      *ngIf="delta"
      class="pay-kpi__delta"
      [class.pay-kpi__delta--up]="delta.direction === 'up'"
      [class.pay-kpi__delta--down]="delta.direction === 'down'">
      {{ delta.value }}
    </span>
  </div>

  <span class="pay-kpi__label">{{ label }}</span>
</div>
